package kz.dentalcrm.app.data.network.response_model.initial_inspection

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class InitialInspectionType(
    val id: Int,
    val name: String,
    @SerialName("created_at")
    val createdAt: String? = null,
    @SerialName("updated_at")
    val updatedAt: String? = null,
    val options: List<InspectionOption> = emptyList(),
    @SerialName("custom_options")
    val customOptions: List<CustomOption> = emptyList()
)

@Serializable
data class InspectionOption(
    val id: Int,
    val value: String,
    @SerialName("init_inspection_type_id")
    val initInspectionTypeId: Int? = null,
    @SerialName("is_custom")
    val isCustom: Int = 0,
    @SerialName("created_at")
    val createdAt: String? = null,
    @SerialName("updated_at")
    val updatedAt: String? = null,
    @SerialName("initialInspections")
    val initialInspections: List<InitialInspection> = emptyList()
)

@Serializable
data class InitialInspection(
    val id: Int,
    @SerialName("appointment_id")
    val appointmentId: Int,
    @SerialName("created_at")
    val createdAt: String? = null,
    @SerialName("updated_at")
    val updatedAt: String? = null,
    @SerialName("inspection_type_id")
    val inspectionTypeId: Int,
    @SerialName("inspection_option_id")
    val inspectionOptionId: Int
)

@Serializable
data class CustomOption(
    val id: Int? = null,
    val value: String? = null
)
